export const indexesExclusive = {
    premium:['SP500','TSX60','BMVIPC','AEX25','BEL20','DAX40',
        'FTSEMIB','FTSE100','NIFTY50','KOSPI','IBOVESPA'],
    pro:['ISEQ20','OMXC25','OMXS30','OMXH25','OBXO25',
        'HSI50','STI','ASX50','CLXIPSA','SA40']
}